import React from "react";
import img01 from "../../assets/img/team/team_img01.png";
import img02 from "../../assets/img/team/team_img02.png";
import img03 from "../../assets/img/team/team_img03.png";
import img04 from "../../assets/img/team/team_img04.png";
import img05 from "../../assets/img/team/team_img05.png";
import img06 from "../../assets/img/team/team_img06.png";
import img07 from "../../assets/img/team/team_img07.png";

import TeamOneItem from "./TeamOneItem";

const TeamOne = () => {
  const team_members = [
    {
      src: img01,
      name: "Dr Simon Platt",
      designation: "(CEO and Founder)  Orthopaedic Surgeon",
      linkedin: "https://www.linkedin.com/in/simon-platt-3478281a/",
    },
    {
      src: img02,
      name: "Dr Gillian Jackson",
      designation: "(Co-Founder)  Orthopaedic Surgeon",
    },
    {
      src: img03,
      name: "Dr Russell Martin",
      designation: "(Co-Founder) Mathematician & Data Scientist",
      linkedin:"https://www.linkedin.com/in/russell-martin-474076ab",
    },
    {
      src: img04,
      name: "Dr Leszek Gąsieniec",
      designation: "(Co-Founder) Professor in Algorithms",
      linkedin:"https://www.linkedin.com/in/leszek-a-g%C4%85sieniec-4958722b/?originalSubdomain=uk",
    },
    {
      src: img05,
      name: "Dr Richard Satur",
      designation: "(Co-Founder) PhD in AI and Big-Data Mining",
      linkedin:"https://www.linkedin.com/in/richardsatur/",
    },
    {
      src: img06,
      name: "Phil Jimmieson",
      designation: "Lecturer at University of Liverpool",
      linkedin:"https://www.linkedin.com/in/phil-jimmieson-7471395/",
    },
    {
      src: img07,
      name: "Brad Gillan",
      designation: "Solutions Architect",
      linkedin:"https://www.linkedin.com/in/brad-gillan-6b22a94/",
    },
  ];

  return (
    <section className="team-area pt-130">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-6">
            <div className="section-title text-center mb-70">
              <h2 className="title">
                Meet the Minds Behind <span>Diagnostica</span>
              </h2>
            </div>
          </div>
        </div>

        <div className="row justify-content-center">
          {team_members.map((member, index) => (
            <div key={index} className="col-xl-3 col-md-4 col-sm-6">
              <TeamOneItem item={member} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TeamOne;
